import { JobOpeningsRelatedSkillsTable } from './JobOpeningsRelatedSkillsTable';
import { JobOpeningsSearchTermTable } from './JobOpeningsSearchTermTable';
import { useGlobalSearchTableParams } from '../../../global-search/use-global-search-table-params';

import type { FunctionComponent } from 'react';

export const JobOpeningsTable: FunctionComponent = () => {
    const { isValidSearchTerm, isValidSkillIdsList, searchTermResult, skillIds } = useGlobalSearchTableParams();

    if (isValidSearchTerm) {
        return <JobOpeningsSearchTermTable searchTerm={searchTermResult} />;
    }

    if (isValidSkillIdsList) {
        return <JobOpeningsRelatedSkillsTable skillIds={skillIds} />;
    }

    return null;
};
